import Urls from "../../constants/urls";
import Entrance from "./imgs/Entrance.jpg";
import View from "./imgs/View.jpg";

export const homeUrl = Urls.emptyShowroom.entrance.path;

export const entranceHotspots = [
    {
        type: "spot",
        xPosition: -140,
        yPosition: -30,
        zPosition: 0,
        xRotation: -80,
        yRotation: 90,
        zRotation: 0,
        radius: 10,
        link: Urls.emptyShowroom.view.path,
    }
];
export const viewHotspots = [
    {
        type: "spot",
        xPosition: -120,
        yPosition: -90,
        zPosition: 0,
        xRotation: -90,
        yRotation: 90,
        zRotation: 0,
        radius: 12,
        link: Urls.emptyShowroom.entrance.path,
    }
];

export const rooms = [
    {
        name: "Entrance",
        img: Entrance,
        route: Urls.emptyShowroom.entrance,
        yRotation: 360,
    },
    {
        name: "View",
        img: View,
        route: Urls.emptyShowroom.view,
        yRotation: 360,
    },
];
